import { createSlice } from "@reduxjs/toolkit";

export const slice = createSlice({
    name:'toast',
    initialState:{
        msg: '',
        type:'',
    },
    reducers:{
        setMsg:(state,action)=>{
            state.msg = action.payload
        },
        deleteMsg:(state)=>{
            state.msg = ''
        },
    },
})

const {setMsg,deleteMsg} = slice.actions

export const displayToast = (text:string)=>(dispatch:any)=> dispatch(setMsg(text))

export const removeToast = () => (dispatch: any) => dispatch(deleteMsg())

export const selectToastMsg = (state: any) => state.toast.msg

export default slice.reducer